import { getEmailVerificationStatus } from '@nesso/identity-contracts/email-verification.queries';
import { userChangePassword } from '@nesso/identity-contracts/password.commands';
import { getPasswordStatus } from '@nesso/identity-contracts/password.queries';
import { userChangeEmail, userConfirmIdentity } from '@nesso/identity-contracts/user.commands';
import { userInfoSchema } from '@nesso/identity-contracts/user.models';

export const getUserResponseSchema = userInfoSchema;

export const passwordStatusSchema = getPasswordStatus.output;

export const emailVerificationStatusSchema = getEmailVerificationStatus.output;

export const changePasswordInputSchema = userChangePassword.input.omit({
    email: true,
    sessionId: true,
});

export const confirmIdentityInputSchema = userConfirmIdentity.input.omit({
    email: true,
    sub: true,
});

export const changeEmailInputSchema = userChangeEmail.input.omit({
    email: true,
    sub: true,
    sessionId: true,
    confirmationToken: true,
});
